import { render, staticRenderFns } from "./RecipePacking.vue?vue&type=template&id=2fba8866&scoped=true"
import script from "./RecipePacking.vue?vue&type=script&lang=ts"
export * from "./RecipePacking.vue?vue&type=script&lang=ts"
import style0 from "./RecipePacking.vue?vue&type=style&index=0&id=2fba8866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba8866",
  null
  
)

export default component.exports